export const VERYF_LOADING = 'VERYF_LOADING';
export const VERYF_LOADED = 'VERYF_LOADED';
export const VERYF_ERROR = 'VERYF_ERROR';

export const RECUPERAR_LOADING = 'RECUPERAR_LOADING';
export const RECUPERAR_LOADED = 'RECUPERAR_LOADED';
export const RECUPERAR_ERROR = 'RECUPERAR_ERROR';